import script from "./AuditLogList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuditLogList.vue?vue&type=script&setup=true&lang=ts"

import "./AuditLogList.vue?vue&type=style&index=0&id=26710bd0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26710bd0"]])

export default __exports__